import { unsubscribeNewsletter } from '@/api/newsletter';
import { Button, Container } from '@/components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type UnsubscribeState = 'confirming' | 'submitting' | 'confirmed' | 'error';

export const UnsubscribePage = () => {
  const { t } = useTranslation();
  const [token] = useState(() => new URLSearchParams(window.location.search).get('token') ?? '');
  const [state, setState] = useState<UnsubscribeState>('confirming');

  useEffect(() => {
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.hash}`);
  }, []);

  const confirmUnsubscribe = async () => {
    setState('submitting');
    try {
      await unsubscribeNewsletter(token);
      setState('confirmed');
    } catch {
      setState('error');
    }
  };

  return (
    <Container max={760}>
      <section className="py-14 sm:py-20">
        <div
          className="p-7 sm:p-10"
          style={{
            background: 'var(--paper-50)',
            border: '2px solid var(--ww-charcoal)',
            boxShadow: '5px 5px 0 var(--ww-charcoal)',
          }}>
          <div className="ww-eyebrow" style={{ color: 'var(--ww-orange)' }}>
            {t('newsletter_unsubscribe_eyebrow')}
          </div>
          <h1 className="mt-3 font-disp text-5xl uppercase leading-none text-ww-charcoal sm:text-6xl">
            {t('newsletter_unsubscribe_title')}
          </h1>

          {state === 'confirmed' ? (
            <p className="mt-6 font-sans text-lg leading-relaxed text-ink-soft" role="status">
              {t('newsletter_unsubscribe_complete')}
            </p>
          ) : (
            <>
              <p className="mt-6 font-sans text-lg leading-relaxed text-ink-soft">
                {t('newsletter_unsubscribe_description')}
              </p>
              {state === 'error' ? (
                <p className="mt-4 font-sans text-sm text-ww-orange" role="alert">
                  {t('newsletter_unsubscribe_error')}
                </p>
              ) : null}
              <Button
                className="mt-8"
                disabled={state === 'submitting'}
                onClick={() => void confirmUnsubscribe()}
                size="lg">
                {state === 'submitting'
                  ? t('newsletter_unsubscribe_pending')
                  : t('newsletter_unsubscribe_confirm')}
              </Button>
            </>
          )}
        </div>
      </section>
    </Container>
  );
};
